export const COLORS = {
  PRIMARY: '#df5f2c',
  LINK: '#707a96',

  PRIMARY_BLUE: '#2980b9',
  DANGER_RED: '#e74c3c',
  SUCCESS_GREEN: '#27ae60',

  BUTTON_BORDER_BLUE: '#2980b9',
  BUTTON_TEXT_BLUE: '#2980b9',
};